﻿import $ from 'jquery';
import ko from 'knockout';
import { IBinder, IExternalElementBinder, ICellBinding, ISubscribeFunction, IBehaviorFunction } from "./ibinder"
import { JsonBuilder } from "../jsonbuilder";

export class ExternalJsonBinder implements IExternalElementBinder {
  key: string = "ExternalJson";
  constructor(private tableKey: string) { }

  getElements(): JQuery {
    return $("[data-et-json='" + this.tableKey + "']");
  }

  public compute(tableData): Function {
    return ko.computed(() => {
      return JsonBuilder.toJSON(tableData);
    });
  }

  public subscribe: ISubscribeFunction = (value) => {
    var $elements = this.getElements();
    $elements.each(function () {
      $(this).val(value);
    });
  }

  public extend(): IBehaviorFunction {
    return null;
  }
}
